module.exports = __webpack_public_path__ + "static/media/help.eb452c0d.svg";